import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import { CircularProgress } from "@mui/material";

const SiteLayout = function () {
  const [load, setLoad] = useState(false);

  useEffect(() => {
    setLoad(true);
    setTimeout(() => {
      setLoad(false);
    }, 1000);
  }, []);

  return (
    <div style={{ position: "relative", overflow: "visible" }}>
      {load ? (
        <div className="flex flex-col gap-4 w-screen h-screen justify-center items-center">
          <CircularProgress size={60} color="primary" />
        </div>
      ) : (
        <div className="flex min-h-screen">
          <Sidebar />
          <main className="flex-1 ml-0 md:ml-64  transition-all duration-300">
            <Outlet />
          </main>
        </div>
      )}
    </div>
  );
};

export default SiteLayout;
